module.exports = __webpack_public_path__ + "img/img22.800aa2f0.jpeg";